<template>
  <div class="page container">

    <div class="row">
      <div class="col-12 text-left">

        <h3> <b>Adicionar Regiões</b> </h3>

 <div class="form-group">
    <label for="exampleFormControlInput1">Nome</label>
                <input type="text" class="form-control col-6" v-model="regiao.nome" placeholder="">
  </div>
 <div class="form-group">
    <label for="exampleFormControlInput1">Valor mínimo para entrega</label>
                            <input type="text" class="form-control col-6" v-model="regiao.valorMinimo" placeholder="">
  </div>
 <div class="form-group">
    <label for="exampleFormControlInput1">Observação</label>
    <input type="text" class="form-control col-6" v-model="regiao.obs" placeholder="">
  </div>

          <div class="form-group form-inline">          
                <button @click="$store.dispatch('cadastraRegiao', regiao)" class='btn btn-primary'> Adicionar </button>
            </div>

       
      </div>
    </div>


 
<div class="row mt-5"  >
    <div class="col text-left">

        <h3> <b>Regiões Cadastradas</b> </h3>
        <!-- <hr/> -->

        <regiao-edit-item v-for="local in locaisEntregas" 
          :key="local.id"
          :item="local">
        </regiao-edit-item>

    </div>

</div>




       
       

  </div>
</template>

<script>

import regiaoEditItem from '@/components/regiao-edit-item.vue'
// import QuantidadeSelector from '@/components/elementos/quantidade-selector'

export default {
        components:{
            regiaoEditItem,
            // SelecionarProdutoEdit
        },

        

  data(){
    return {
      regiao:{
        nome:'',
        valorMinimo:0,
        obs:''
      },
      nomeRegiao:'',
      error:'',
      enviado:false,
      produto:{
        id:false,
        nome:'',
        medida:'',
        incremento:'',
        preco:'',
        disponivel:0,
        informacoesadicionais:'',
      }
    }
  },




  computed:{
      locaisEntregas:function(){
          return this.$store.getters.locaisEntregas
      },
     
  },

  methods:{

    atualizarProduto:async function(){
      this.error = ""
    },

    cadastrarProduto:async function(){
      this.error = ""

     if(this.$refs['produto'].checkValidity()){
        let res
        debugger;
       if(this.produto.id != false){
           res = await this.$store.dispatch('updateProduto', this.produto)
       }else{
           res = await this.$store.dispatch('cadastraProduto', this.produto)
       }
        if(res!=false){
            this.enviado = true
            this.produto = {
                id:false,
                nome:'',
                medida:'',
                incremento:'',
                preco:'',
                disponivel:0,
                informacoesadicionais:'',
          }
          this.$router.replace({params:{}})
        }else{
          this.error = "Ocorreu um erro ao salvar o produto. Tente novamente."
        }
      }else{
          // alert("Preencha os dados")
          this.error = "Preencha os dados corretamente"
      }
    }
  }

}
</script>
